import { Box, useMediaQuery, useTheme } from '@mui/material';
import { ReactComponent as LogoImg } from '../../../../../assets/circleK-logo-color.svg';

function HeaderLogoCircleK() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      sx={(theme) => ({
        fontSize: isMobile ? '0.6rem' : undefined,
        color: theme.palette.text.primary,
        display: 'flex',
      })}
    >
      <LogoImg height="3em" />
    </Box>
  );
}

export default HeaderLogoCircleK;
